export default __webpack_public_path__ + "static/media/8t.75f09d08.jpg";